import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4fdb9014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "functional-location-info" }
const _hoisted_2 = { class: "info-title" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = {
  key: 0,
  class: "info-title"
}
const _hoisted_5 = {
  key: 1,
  class: "info-title"
}
const _hoisted_6 = {
  key: 2,
  class: "info-value"
}
const _hoisted_7 = {
  key: 3,
  class: "info-value"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "asset-details"
}

import { ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";
import { AssetClass, FunctionalLocation } from "@/classes";
import NumberField from "../base/inputs/NumberField.vue";
import { useListStore } from "@/store/lists";


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalLocationDialog',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emits = __emit;

const dialog = ref(false);
const functionallocation = ref<FunctionalLocation>(new FunctionalLocation());
const loading = ref(false);

const lists = useListStore();
const assetClasses = lists.useList<AssetClass>("assetClasses");

const open = async (id: string | null) => {
  dialog.value = true;
  if (id) {
    functionallocation.value = await FunctionalLocation.get(id);
  } else {
    functionallocation.value = new FunctionalLocation();
  }
};

const fields: { title: string; key: keyof FunctionalLocation }[] = [
  { title: "Functional Location", key: "functional_location" },
  {
    title: "Superior Functional Location",
    key: "superior_functional_location",
  },
  {
    title: "Functional Location Description",
    key: "functional_location_description",
  },
  { title: "Construction Type", key: "construction_type" },
  { title: "Planning Plant", key: "planning_plant" },
  { title: "Location", key: "location" },
  { title: "Accounting Assesment", key: "accounting_assesment" },
  { title: "Maintenance Plant", key: "maintenance_plant" },
  { title: "Company Code", key: "company_code" },
  { title: "Cost Center", key: "cost_center" },
  { title: "Planner Group", key: "planner_group" },
  { title: "Sort Field", key: "sort_field" },
  { title: "Main Work Center", key: "main_work_center" },
  { title: "Manufacturer", key: "manufacturer" },
  { title: "Manufacturer Serial Number", key: "manufacturer_serial_number" },
  { title: "Entity ID", key: "entity_id" },
  {
    title: "Functional Location Category",
    key: "functional_location_category",
  },
  { title: "Catalog Profile", key: "catalog_profile" },
  { title: "Object Number", key: "object_number" },
  { title: "Length", key: "length" },
];

const save = async () => {
  loading.value = true;
  await functionallocation.value.save();
  loading.value = false;
  dialog.value = false;
  emits("change", functionallocation.value.id);
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
    maxWidth: "1000",
    title: "Functional Location"
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.filter((_, i) => i % 2 === 0), (_, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(fields[i * 2].title), 1),
              _createElementVNode("td", _hoisted_3, _toDisplayString(functionallocation.value[fields[i * 2].key]), 1),
              (i * 2 + 1 < fields.length)
                ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(fields[i * 2 + 1].title), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_5)),
              (i * 2 + 1 < fields.length)
                ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(functionallocation.value[fields[i * 2 + 1].key]), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_7))
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { style: {"display":"flex"} }, {
            default: _withCtx(() => [
              (functionallocation.value.is_asset)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Asset Details"))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              (functionallocation.value.parent_id === null)
                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 1,
                    modelValue: functionallocation.value.hide_from_tree_top,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((functionallocation.value.hide_from_tree_top) = $event)),
                    label: "Hide From Top Level",
                    "false-value": false,
                    "true-value": true,
                    variant: "outlined",
                    density: "compact",
                    class: "mr-4",
                    "hide-details": "",
                    clearable: "",
                    readonly: _ctx.readonly
                  }, null, 8, ["modelValue", "readonly"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_checkbox, {
                modelValue: functionallocation.value.is_asset,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((functionallocation.value.is_asset) = $event)),
                label: "Is Asset",
                "false-value": false,
                "true-value": true,
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                clearable: "",
                readonly: _ctx.readonly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          (functionallocation.value.is_asset)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(NumberField, {
                  modelValue: functionallocation.value.hours_per_day,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((functionallocation.value.hours_per_day) = $event)),
                  label: "Hours Per Day",
                  suffix: "hrs",
                  variant: "outlined",
                  density: "compact",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "readonly"]),
                _createVNode(_component_v_autocomplete, {
                  modelValue: functionallocation.value.asset_class_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((functionallocation.value.asset_class_id) = $event)),
                  label: "Asset Class",
                  items: _unref(assetClasses),
                  "item-value": "id",
                  "item-title": "name",
                  clearable: "",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "items", "readonly"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!_ctx.readonly)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _createVNode(_component_v_btn, {
              loading: loading.value,
              onClick: save
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})